import axios from "axios";

// Get tokenz from localStorage
const token = localStorage.getItem("jwt")?.replace(/"/g, "");
const csrftoken = localStorage.getItem("csrfToken")?.replace(/"/g, "");

export const Auth_Instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    ...(token && { Authorization: `token ${token}` }),
    ...(csrftoken && { "X-CSRFToken": csrftoken }),
  },
});

export const Geste_Instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});
